import { ArrayWrap } from "@/mixins";
import { TagType } from "./tag-type";

export class SlyShoppingPrizeView {
  id?: string;
  email?: string;
  prizeStatus?: string;
  prize_sent?: Date;
  validity?: Date;
  prize?: string;
  auth_id?: string;
  phone?: string;
  wave_id?: string;
  start?: Date;
  validUntil?: Date;
}

class StatusTranslate {
  statusCode: StatusCode;
  nameRus: string;
  displayType: TagType;
  constructor(clientCode: StatusCode, nameRus: string, displayType: TagType) {
    this.statusCode = clientCode;
    this.nameRus = nameRus;
    this.displayType = displayType;
  }
}

export enum StatusCode {
  SMS_SENT = "sms_sent",
  REJ_DOUBLE_CH = "rejected_double_ch",
  REJ_LESS = "rejected_less_than_limit",
  REJ_INV = "rejected_wo_invoice",
  COMPLITED = "complited",
  CREATED = "created",
  IN_PROGRESS = "in_progress",
  EMAIL_SENT = "email_sent",
  REJ_EMAIL_MISSING = "rejected_email_missing",
  ERR_GET_INV = "error_couldnot_get_invoices",
  ERR_PRIZE_DESC = "error_bad_prize_desc",
  ERR_TRANSFER_POINTS = "error_couldnot_transfer_points",
  ERR_TRANSFER_COUPON = "error_couldnot_transfer_coupon",
  ERR_EMAIL_BAD = "error_bad_email_desc",
  ERR_SMS_SENT = "error_sms_was_not_sent",
  ERR_EMAIL_SENT = "error_email_was_not_sent",
  PRIZE_ISSUED = "prize_issued",
  PRIZE_REDEEMED = "prize_redeemed",
}

export const StatusTranslateByEnum: ArrayWrap<StatusTranslate> = {
  [StatusCode.PRIZE_ISSUED]: new StatusTranslate(StatusCode.PRIZE_ISSUED, "Приз уже выдан", ""),
  [StatusCode.PRIZE_REDEEMED]: new StatusTranslate(StatusCode.PRIZE_REDEEMED, "Приз отменен", "warning"),

  [StatusCode.SMS_SENT]: new StatusTranslate(StatusCode.SMS_SENT, "SMS отправлено", ""),
  [StatusCode.COMPLITED]: new StatusTranslate(StatusCode.COMPLITED, "Завершен", ""),
  [StatusCode.CREATED]: new StatusTranslate(StatusCode.CREATED, "Создан", ""),
  [StatusCode.IN_PROGRESS]: new StatusTranslate(StatusCode.IN_PROGRESS, "В обратотке", ""),
  [StatusCode.EMAIL_SENT]: new StatusTranslate(StatusCode.EMAIL_SENT, "Email отправлен", ""),

  [StatusCode.REJ_INV]: new StatusTranslate(StatusCode.REJ_INV, "Отменено: нет покупки", "warning"),
  [StatusCode.REJ_EMAIL_MISSING]: new StatusTranslate(
    StatusCode.REJ_EMAIL_MISSING,
    "Отменено: email не найден",
    "warning"
  ),
  [StatusCode.REJ_DOUBLE_CH]: new StatusTranslate(
    StatusCode.REJ_DOUBLE_CH,
    "Отменено: дубль держателя",
    "warning"
  ),
  [StatusCode.REJ_LESS]: new StatusTranslate(
    StatusCode.REJ_LESS,
    "Отменено: покупка меньше лимита",
    "warning"
  ),

  [StatusCode.ERR_GET_INV]: new StatusTranslate(
    StatusCode.ERR_GET_INV,
    "Ошибка: покупки не найдены",
    "danger"
  ),
  [StatusCode.ERR_PRIZE_DESC]: new StatusTranslate(
    StatusCode.ERR_PRIZE_DESC,
    "Ошибка: неверное описание приза",
    "danger"
  ),
  [StatusCode.ERR_TRANSFER_POINTS]: new StatusTranslate(
    StatusCode.ERR_TRANSFER_POINTS,
    "Ошибка: не удалось начислить баллы",
    "danger"
  ),
  [StatusCode.ERR_TRANSFER_COUPON]: new StatusTranslate(
    StatusCode.ERR_TRANSFER_COUPON,
    "Ошибка: не удалось отправить купон",
    "danger"
  ),
  [StatusCode.ERR_EMAIL_BAD]: new StatusTranslate(
    StatusCode.ERR_EMAIL_BAD,
    "Ошибка: неверно указан email",
    "danger"
  ),
  [StatusCode.ERR_SMS_SENT]: new StatusTranslate(
    StatusCode.ERR_SMS_SENT,
    "Ошибка: не удалось отправить sms",
    "danger"
  ),
  [StatusCode.ERR_EMAIL_SENT]: new StatusTranslate(
    StatusCode.ERR_EMAIL_SENT,
    "Ошибка: не удалось отправить email",
    "danger"
  ),
};
